import Shared from "emun.cart/cart.controller";
import templateUrl from "emun.cart/cart.htm";
import shipOnsUrl from "emun.cart/cart-list.ship-ons.htm";

export class CartController extends Shared {
  $onInit() {
    const $ctrl = this;
    //console.debug("CartController$onInit", this);
    //console.debug("BL*** token", $ctrl.token);
    if ($ctrl.cartId && $ctrl.$cart && $ctrl.$cart.load) {
      $ctrl.$cart.load($ctrl.cartId, $ctrl.token);
    } else if ($ctrl.cart, $ctrl.token) {
      $ctrl.$cart = $ctrl.order = $ctrl.cart;
    }
    $ctrl.itementry = $ctrl.itemEntry;
    if ($ctrl.$cart) {
      $ctrl.$cart.shipOnsUrl = shipOnsUrl;
    }
  }
}

export default {
  bindings: {
    cartId: "<?",
    cart: "<?",
    itemEntry: "@",
    hideHeading: "<?",
    token: "@"
  },
  controller: CartController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
